import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import compose from 'helpers/compose';
import FormTextField from 'components/FormFields/FormTextField';
import Background from 'components/Layout/Background';

import SignedDocuments from 'pages/Accounts/Detail/SignedDocuments/SignedDocuments';

const BOSignedDocuments: React.FC = () => {
  const { t } = useTranslation();
  const [accountId, setAccountId] = useState('');

  return (
    <>
      <Container maxWidth="md">
        <Background inside>
          <Typography variant="h1">{t('backOffice_signed_documents_title')}</Typography>

          <Formik initialValues={{ accountId: '' }} onSubmit={() => {}}>
            {(formikProps) => (
              <>
                <Grid container>
                  <Grid item xs={12} container alignItems="center">
                    <Grid item xs={5}>
                      <FormTextField name="accountId" label={t(`backOffice_accountId`)} margin="dense" />
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setAccountId(formikProps.values.accountId)}
                      >
                        {t('general_confirm')}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Formik>
        </Background>
      </Container>

      <SignedDocuments accountId={accountId} backoffice />
    </>
  );
};

export default compose(withRouter, observer)(BOSignedDocuments);
